import { colors } from '../../foundation';

type Props = {
  color:
    | typeof colors.state.error
    | typeof colors.state.warning
    | (typeof colors.white)[100]
    | (typeof colors.neutral)[10];
  size?: number;
};

const Warning = ({ color, size = 16 }: Props) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="StateIcon/Notification Warn">
        <path
          id="Vector"
          d="M14.4223 11.3633L9.75563 2.72078C9.58345 2.40574 9.32964 2.14285 9.02084 1.95971C8.71205 1.77657 8.35965 1.67993 8.00063 1.67993C7.64161 1.67993 7.2892 1.77657 6.98041 1.95971C6.67161 2.14285 6.4178 2.40574 6.24563 2.72078L1.57896 11.3599C1.41233 11.6645 1.32783 12.0072 1.33379 12.3543C1.33975 12.7014 1.43595 13.0409 1.61294 13.3396C1.78992 13.6382 2.0416 13.8857 2.34321 14.0576C2.64482 14.2295 2.98597 14.3199 3.33313 14.3199H12.6665C13.0133 14.3199 13.3541 14.2296 13.6555 14.058C13.9569 13.8864 14.2085 13.6394 14.3856 13.3412C14.5627 13.043 14.6592 12.7038 14.6656 12.3571C14.672 12.0103 14.5882 11.6678 14.4223 11.3633ZM7.66646 5.32161C7.66646 5.23321 7.70158 5.14842 7.76409 5.08591C7.8266 5.0234 7.91139 4.98828 7.99979 4.98828C8.0882 4.98828 8.17298 5.0234 8.2355 5.08591C8.29801 5.14842 8.33313 5.23321 8.33313 5.32161V10.0299C8.33313 10.1184 8.29801 10.2031 8.2355 10.2656C8.17298 10.3282 8.0882 10.3633 7.99979 10.3633C7.91139 10.3633 7.8266 10.3282 7.76409 10.2656C7.70158 10.2031 7.66646 10.1184 7.66646 10.0299V5.32161ZM7.99979 12.0716C7.91738 12.0716 7.83683 12.0472 7.7683 12.0014C7.69978 11.9556 7.64638 11.8905 7.61484 11.8144C7.58331 11.7383 7.57506 11.6545 7.59113 11.5737C7.60721 11.4928 7.64689 11.4186 7.70516 11.3603C7.76344 11.302 7.83768 11.2624 7.91851 11.2463C7.99933 11.2302 8.08311 11.2385 8.15924 11.27C8.23538 11.3015 8.30045 11.3549 8.34624 11.4235C8.39202 11.492 8.41646 11.5725 8.41646 11.6549C8.4158 11.765 8.37161 11.8704 8.29354 11.948C8.21547 12.0256 8.10987 12.0691 7.99979 12.0691V12.0716Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Warning;
